import { Identifiable, Project, Zone } from "@planzone/dto";

enum SortOptions {
  Default = "zonesPage.projects.sorter.default",
  AscendingAlphabeticalOrder = "zonesPage.projects.sorter.ascendingAlphabeticalOrder",
  DescendingAlphabeticalOrder = "zonesPage.projects.sorter.descendingAlphabeticalOrder",
  StartDate = "zonesPage.projects.sorter.startDate",
  EndDate = "zonesPage.projects.sorter.endDate",
  CreationDate = "zonesPage.projects.sorter.creationDate",
}

type SortFunctions = {
  [key in SortOptions]: (
    data: Identifiable<Project>[],
  ) => Identifiable<Project>[];
};
interface Props {
  zoneId: string;
  getZone(zone: Identifiable<Zone>): void;
  getAllZone(): void;
}

export type { Props, SortFunctions };

export { SortOptions };
